import { Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './components/cart/cart-context';
import { ErrorBoundary } from './components/ErrorBoundary';
import { MarketplaceProvider } from './context/MarketplaceContext';
import { Navbar } from './components/layout/navbar/index';
import { WelcomeToast } from './components/welcome-toast';
import { Toaster } from 'sonner';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import SearchPage from './pages/SearchPage';
import UserProfilePage from './pages/UserProfilePage';
import KioskProfilePage from './pages/KioskProfilePage';
import BoutiqueProfilePage from './pages/BoutiqueProfilePage';
import RestaurantProfilePage from './pages/RestaurantProfilePage';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import CheckoutFailedPage from './pages/CheckoutFailedPage';
import ShippingPage from './pages/ShippingPage';
import PaymentPage from './pages/PaymentPage';
import AllKiosksPage from './pages/AllKiosksPage';
import LoginPage from './pages/LoginPage';
import './index.css';

function AppContent() {
  const location = useLocation();
  
  const isCheckout = location.pathname.startsWith('/checkout') || location.pathname.startsWith('/shipping') || location.pathname.startsWith('/payment');
  const isLogin = location.pathname === '/login';

  return (
    <div className="bg-neutral-50 text-black selection:bg-teal-300 dark:bg-neutral-900 dark:text-white dark:selection:bg-pink-500 dark:selection:text-white">
      {!isCheckout && !isLogin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/kiosks" element={<AllKiosksPage />} />
          <Route path="/kiosk/:id" element={<KioskProfilePage />} />
          <Route path="/boutique/:id" element={<BoutiqueProfilePage />} />
          <Route path="/restaurant/:id" element={<RestaurantProfilePage />} />
          <Route path="/product/:handle" element={<ProductPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/search/:collection" element={<SearchPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/checkout/failed" element={<CheckoutFailedPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/:username" element={<UserProfilePage />} />
        </Routes>
        <Toaster closeButton />
        {!isCheckout && <WelcomeToast />}
      </main>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <MarketplaceProvider>
        <CartProvider>
          <AppContent />
        </CartProvider>
      </MarketplaceProvider>
    </ErrorBoundary>
  );
}

export default App;

